import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NetworkService } from 'src/app/core/services/network.service';

export interface KpiRefreshStartResponse {
  success: string;
  error: string;
  refresh_timestamp: string;
  run_id: string;
}

export interface KpiRefreshStatusResponse {
  success: string;
  error: string;
  run_id: string;
  pipeline_status: string;
  checked_timestamp: string;
  run_start: string;
  run_end: string;
  last_updated: string;
}

@Injectable({
  providedIn: 'root'
})
export class DlmService {

  constructor(private netWorkSer: NetworkService) { }

  /**
   * Function that places all rows for a selected KPI at the end of the array.
   */
  placeKPIAtEnd<T extends { KPI: string }>(KPIs: T[], KPIName: string): T[] {
    const otherKPIs = KPIs.filter(kpi => kpi.KPI !== KPIName);
    const selectedKPIs = KPIs.filter(kpi => kpi.KPI === KPIName);

    return [...otherKPIs, ...selectedKPIs];
  }

  startKpiRefresh(payload: any): Observable<KpiRefreshStartResponse> {
    return this.netWorkSer.httpReq('post', 'KPIRefresh', '', payload);
  }

  getKpiRefreshStatus(runId: string): Observable<KpiRefreshStatusResponse> {
    return this.netWorkSer.httpReqDLM('get', 'KPIRefreshStatus', { runId });
  }
}
